import {AfterViewInit, Component, forwardRef, Input} from "@angular/core";
import {ChosenCategoryService} from "../../../../../../../../common/components/business-category/chosen-category.service";
import {ControlValueAccessor, FormGroup, NG_VALUE_ACCESSOR} from "@angular/forms";
import {isNullOrUndefined} from "util";

const CUSTOM_BUSINESS_CATEGORY_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => BusinessCategoryContainerComponent),
    multi: true
};

@Component({
    selector: 'tfl-business-category-container',
    template: `
        <ng-container *ngFor="let category of categories">
            <div class="row form-group">
                <div class="col-xs-11">
                    <input [id]="category.id"
                           [value]="category.code + ' ' + category.name"
                           class="form-control"
                           style="background-color: #fff;"
                           readonly>
                </div>
                <i (click)="removeAndSendEvent(category)" class="fa fa-trash fa-lg"></i>
            </div>
        </ng-container>
    `,
    providers: [CUSTOM_BUSINESS_CATEGORY_CONTROL_VALUE_ACCESSOR]
})
export class BusinessCategoryContainerComponent implements ControlValueAccessor, AfterViewInit {

    @Input('id') id: string;
    @Input('form') formGroup: FormGroup;
    @Input('controlName') controlName: string;
    private categories: any[] = [];

    onChangeEvent: any = () => {
    };
    onTouchedEvent: any = () => {
    };

    constructor(private service: ChosenCategoryService) {
        this.service.selectedCategoryEvent.subscribe(category => {
                if (!this.categories.find(c => c.id == category.id)) {
                    this.categories.push(category);
                    this.patchValue(this.categories);
                }
            }
        );
        this.service.deSelectedCategoryEvent.subscribe(category => {
                this.remove(category);
            }
        );
    }

    private remove(category) {
        this.categories = this.categories.filter(item => item.id !== category.id);
        this.patchValue(this.categories);
    }

    private removeAndSendEvent(category) {
        this.remove(category);
        this.service.deleted(category);
        this.formGroup.controls[this.controlName].markAsDirty();
    }

    registerOnChange(fn: any): void {
        this.onChangeEvent = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouchedEvent = fn;
    }

    writeValue(obj: any): void {
        if (!isNullOrUndefined(obj)) {
            this.categories = obj;
        }
    }

    ngAfterViewInit(): void {
        this.service.loaded(this.categories)
    }

    private patchValue(value) {
        let control = this.formGroup.controls[this.controlName];
        control.setValue(value);
        control.markAsDirty();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/business-categories/categories-agregator/category-container.component.ts